export default "__VITE_ASSET__751136c2__"